import { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface StatCardRowProps {
  label: ReactNode;
  value: ReactNode;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

export const StatCardRow = ({
  label,
  value,
  className,
  labelClassName,
  valueClassName,
}: StatCardRowProps) => {
  return (
    <div className={cn('flex items-center justify-between gap-3', className)}>
      <span className={cn('text-sm text-muted-foreground', labelClassName)}>{label}</span>
      <span className={cn('text-sm font-semibold', valueClassName)}>{value}</span>
    </div>
  );
};
